module.exports = __webpack_public_path__ + "img/Fujimoto.2db6925f.png";